import React, { Component } from 'react';
import './TaskElement.css';
import TextTruncate from 'react-text-truncate';
import cleanWater from './resources/clean-water.png';
import goodHealth from './resources/good-health.png';
import qualityEducation from './resources/quality-education.png';
import noPoverty from './resources/no-poverty.png';
import genderEquality from './resources/gender-equality.png';
import zeroHunger from './resources/zero-hunger.jpg';
import decentWork from './resources/decent-work.png';
import reducedInqualities from './resources/reduced-inequalities.png';
import industryInnovation from './resources/industry-innovation.jpg';
import lifeOnLand from './resources/life-on-land.png';
import climateAction from './resources/climate-action.png';
import partnershipsForTheGoals from './resources/partnerships-for-the-goals.png';
import peaceAndJustice from './resources/peace-and-justice.jpg';
import affordableAndCleanEnergy from './resources/affordable-and-clean-energy.png';
import lifeBelowWater from './resources/life-below-water.png';
import sustainableCities from './resources/sustainable-cities.png';
import responsibleConsumption from './resources/responsible-consumption.png';


class TaskElement extends Component {
  render() {
    let goalIcon = cleanWater;
    switch(this.props.data.globalGoals) {
        case 'Clean Water and Sanitation':
            goalIcon = cleanWater;
            break;
        case 'Good Health and Well-being':
            goalIcon = goodHealth;
            break;
        case 'Quality Education':
            goalIcon = qualityEducation;
            break;
        case 'No Poverty':
            goalIcon = noPoverty;
            break;
        case 'Gender Equality':
            goalIcon = genderEquality;
            break;
        case 'Zero Hunger':
            goalIcon = zeroHunger;
            break;
        case 'Affordable and Clean Energy':
            goalIcon = affordableAndCleanEnergy;
            break;
        case 'Decent Jobs and Economic Growth':
            goalIcon = decentWork;
            break;
        case 'Industry, Innovation and Infrastructure':
            goalIcon = industryInnovation;
            break;
        case 'Reduced Inequalities':
            goalIcon = reducedInqualities;
            break;
        case 'Sustainable Cities and Communities':
            goalIcon = sustainableCities;
            break;
        case 'Responsible Consumption and Production':
            goalIcon = responsibleConsumption;
            break;
        case 'Climate Action':
            goalIcon = climateAction;
            break;
        case 'Life Below Water':
            goalIcon = lifeBelowWater;
            break;
        case 'Life on Land':
            goalIcon = lifeOnLand;
            break;
        case 'Peace and Justice - Strong Institutions':
            goalIcon = peaceAndJustice;
            break;
        case 'Partnerships for the Goals':
            goalIcon = partnershipsForTheGoals;
            break;
        default:
            goalIcon = cleanWater;
    }

    return (
      <div className="project-element" onClick={this.props.onClick}>
        <div className="project-element--header">
        <img src={goalIcon} height="50px" className="project-element--logo" alt="logo" />
          <div className="project-element--taskname">{this.props.data.name}</div>
        </div>
        <div className="project-element--description">
        <TextTruncate
            line={3}
            truncateText="…"
            text={this.props.data.description}
            textTruncateChild={<a href="">Read more</a>}
        />
        <br />
        {this.props.data.projectName &&
          (<p>Part of the <strong>{this.props.data.projectName}</strong> project.</p>)
        }
        {!this.props.data.projectName &&
          (<p><strong>This project needs a solution.</strong></p>)
        }
        </div>
      </div>
    );
  }
}

export default TaskElement;



// WEBPACK FOOTER //
// ./src/TaskElement.js